module.exports = __webpack_public_path__ + "img/logo.5a198b4f.jpg";